import { stripBlank } from "../utils";
import { LoginWithAuth0Options } from "./context";

/**
 * Extracts URL parameters for login flows from URLSearchParams
 */
export const extractUrlParameters = (urlParams: URLSearchParams) => {
  // Helper function to get parameter or undefined if empty or null
  const getParam = (key: string) => {
    const value = urlParams.get(key);
    return value === "" || value === null ? undefined : value;
  };

  return {
    email: getParam("email"),
    screen_hint: getParam("screen_hint"),
    token: getParam("token"),
    prompt: getParam("prompt"),
    _gl: getParam("_gl"),
    utm_source: getParam("utm_source"),
    utm_medium: getParam("utm_medium"),
    utm_campaign: getParam("utm_campaign"),
    utm_content: getParam("utm_content"),
    utm_referer: getParam("utm_referer"),
    gclid: getParam("gclid"),
    fbclid: getParam("fbclid"),
    msclkid: getParam("msclkid"),
    li_fat_id: getParam("li_fat_id"),
    ext_gaClientId: getParam("ext-gaClientId"),
    ext_gaSessionId: getParam("ext-gaSessionId"),
    ext_anonymousId: getParam("ext-anonymousId"),
  };
};

/**
 * Builds LoginWithAuth0Options from extracted URL parameters
 */
export const buildLoginOptions = (
  params: ReturnType<typeof extractUrlParameters>
): LoginWithAuth0Options => {
  const appState: LoginWithAuth0Options["appState"] = stripBlank({
    _gl: params._gl,
    utm_source: params.utm_source,
    utm_medium: params.utm_medium,
    utm_campaign: params.utm_campaign,
    utm_content: params.utm_content,
    utm_referer: params.utm_referer,
    gclid: params.gclid,
    fbclid: params.fbclid,
    msclkid: params.msclkid,
    li_fat_id: params.li_fat_id,
  });

  const additionalAuthorizationParams: LoginWithAuth0Options["additionalAuthorizationParams"] =
    stripBlank({
      "ext-gaClientId": params.ext_gaClientId,
      "ext-gaSessionId": params.ext_gaSessionId,
      "ext-anonymousId": params.ext_anonymousId,
      prompt: params.prompt,
    });

  let opts: LoginWithAuth0Options = stripBlank({
    email: params.email,
    screen_hint: params.screen_hint ?? "login", // default to "login" if not provided
    token: params.token,
  });

  if (Object.keys(additionalAuthorizationParams).length > 0) {
    opts = {
      additionalAuthorizationParams,
      ...opts,
    };
  }

  if (Object.keys(appState).length > 0) {
    opts = {
      appState,
      ...opts,
    };
  }

  return opts;
};
